import React from 'react';
import { Box } from '@mui/material';
import ServiceHeader from '../Node/ServiceHeader';
import { DrawerEmpty } from '../Node/DrawerStates';

function NoMetricAvailable(props) {
  const { root } = props;

  return (
    <Box>
      <ServiceHeader
        title={root.data.displayName}
        subtitle={
          root.data.descriptionLines.length > 0
            ? root.data.descriptionLines[0]
            : ''
        }
      />
      <DrawerEmpty>No metrics available...</DrawerEmpty>
    </Box>
  );
}

export default NoMetricAvailable;
